import type { FaireProductEntity } from "../../entity_types/product";

export const p_j693pnppdd: FaireProductEntity = {
  token: "p_j693pnppdd",
  type: "product",
  name: "Newborn Swaddle Sash Maternity Sash with Big Bowknot Plaid",
  brandToken: "b_g39ej8ubtw",
  brandName: "Morxy LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/089940f8709d79c4a40614505338c9bcdf0018e9bd36ceb9f0b0800f60214328.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/92e4344bcce29ec323232e2494cd7d9668588ef15e3b9f50bc63b18e89b3eeac.jpeg",
    "https://cdn.faire.com/fastly/7b18facaf99f1a1ff44e26b467e766a50ea77f27f3e49f03d691aeb4b25e784d.jpeg",
    "https://cdn.faire.com/fastly/a3943f6aa254b4a0d1452682a149fd556c8d3a446c125390c2f9d2f0702c6efc.jpeg",
    "https://cdn.faire.com/fastly/e1366740346118081790423f83a25c0a96c1fb652899d0457c0cc965d689629a.jpeg",
  ],
  priceDollars: 11,
  description:
    "Beautiful Sash for Newborns: Capture unforgettable moments with our stunning baby sash, perfect for newborn photography. It adds a charming touch to your baby’s first photos, creating lasting memories to admire for years.\n\nMaterial: Gentle, skin-friendly cotton bow swaddle wrap ensures maximum comfort to your newborn's delicate skin. Its soft texture keeps baby content and snug during sleep and those adorable photo sessions.\n\nSuitable Occasions: Our swaddle bow is perfect for special moments like maternity shoots, newborn baby props, nursery decor, and gender reveals. It's elegant enough to transform every occasion into a beautiful memory.\n\nA Thoughtful Gift: Combining elegance and personalization, it is a wonderful gift for new parents that helps celebrate their baby’s early days. Perfect for baby showers or welcoming little ones, it honors the joy of new beginnings.\n\nIt measures 75\" x 5\".",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:00.326Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
